// import {
//   TextField,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   InputAdornment,
// } from "@mui/material";
// import React, { useState, useEffect } from "react";
// import { Modal, Row, Col } from "react-bootstrap";
// import { AiFillDelete, AiFillEdit } from "react-icons/ai";

// import { server } from "../common";
// import { AxiosError } from "axios";
// import { useFormik } from "formik";
// import { toast } from "react-toastify";
// import * as Yup from "yup";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import { useSelectAccess } from "../store/stateFunctions";

// AboutUs.jsx
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { TextField, Button } from "@mui/material";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { server } from "../common";
import * as Yup from "yup";
import { useSelectAccess } from "../store/stateFunctions";


const AboutUs = () => {
  const user = useSelectAccess("Super Admin") || {};
  const token = user.authToken || localStorage.getItem("superadminToken");
  
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState("add"); // 'add' | 'edit'
  const [selected, setSelected] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleClose = () => {
    setShow(false);
    setSelected(null);
    setMode("add");
    setPreview(null);
    formik.resetForm();
  };

  const openAdd = () => {
    setMode("add");
    setSelected(null);
    formik.setValues({ title: "", description: "", image: null });
    setPreview(null);
    setShow(true);
  };

  const openEdit = (item) => {
    setMode("edit");
    setSelected(item);
    formik.setValues({
      title: item.title || "",
      description: item.description || "",
      image: null,
    });
    setPreview(null);
    setShow(true);
  };

  const getData = () => {
    server
      .get("/about/getallabout")
      .then((res) => setData(res.data || []))
      .catch(() => toast.error("Failed to load About Us data"));
  };

  useEffect(() => {
    getData();
  }, []);

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      image: null,
    },
    enableReinitialize: false,
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("description", values.description);
        if (values.image) formData.append("image", values.image);

        if (mode === "add") {
          await server.post("/about/addabout", formData, {
            headers: { 
              Authorization: token,
              // Don't set Content-Type manually for FormData - axios will set it automatically with boundary
            },
          });
          toast.success("About Us added successfully");
        } else if (mode === "edit" && selected?.id) {
          await server.put(`/about/updateabout/${selected.id}`, formData, {
            headers: { 
              Authorization: token,
              // Don't set Content-Type manually for FormData - axios will set it automatically with boundary
            },
          });
          toast.success("About Us updated successfully");
        } else {
          toast.error("Invalid operation");
          return;
        }

        handleClose();
        getData();
      } catch (e) {
        toast.error("Save failed");
      }
    },
  });

  const onFileChange = (e) => {
    const file = e.currentTarget.files?.[0];
    formik.setFieldValue("image", file || null);
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => setPreview(ev.target.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };

  const onDelete = async (item) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      await server.delete(`/about/deleteabout/${item.id}`, {
        headers: { Authorization: token },
      });
      toast.success("Deleted successfully");
      getData();
    } catch {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">About Us</h3>
        {/* <Button variant="contained" color="primary" onClick={openAdd}>
          Add About Us
        </Button> */}
      </div>

      <div className="row">
        {(data || []).map((item) => (
          <div className="col-md-6 mb-4" key={item.id}>
            <div className="card shadow-lg rounded-3 p-3 h-100 d-flex">
              <div className="mb-2">
                
                <h4 className="mb-1">Title:{item.title}</h4>
                {/* <small className="text-muted">ID: {item.id}</small> */}
                <h5>Description :</h5>
              </div>
              <p className="flex-grow-1" style={{ whiteSpace: "pre-wrap" }}>
                {item.description}
              </p>

              {item.image && (
                <img
                  src={item.image}
                  alt={item.title}
                  className="img-fluid rounded mb-2"
                  style={{ maxHeight: "250px", objectFit: "cover" }}
                />
              )}

              <div className="d-flex gap-2 mt-auto">
                <Button
                  variant="contained"
                  color="info"
                  onClick={() => openEdit(item)}
                >
                  Update
                </Button>
                {/* <Button
                  variant="outlined"
                  color="error"
                  onClick={() => onDelete(item)}
                >
                  Delete
                </Button> */}
              </div>
            </div>
          </div>
        ))}
        {(!data || data.length === 0) && (
          <div className="col-12">
            <div className="text-center text-muted">No About Us records found.</div>
          </div>
        )}
      </div>

      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{mode === "add" ? "Add About Us" : "Edit About Us"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <TextField
                name="title"
                label="Title"
                value={formik.values.title}
                onChange={formik.handleChange}
                fullWidth
              />
              {formik.errors.title && (
                <p className="text-danger">{formik.errors.title}</p>
              )}
            </div>

            <div className="mb-3">
              <TextField
                name="description"
                label="Description"
                value={formik.values.description}
                onChange={formik.handleChange}
                multiline
                rows={5}
                fullWidth
              />
              {formik.errors.description && (
                <p className="text-danger">{formik.errors.description}</p>
              )}
            </div>

            <div className="mb-3">
              <input type="file" accept="image/*" onChange={onFileChange} />
              {preview && (
                <div className="mt-2">
                  <p className="mb-1">Preview:</p>
                  <img
                    src={preview}
                    alt="preview"
                    style={{
                      width: "140px",
                      height: "110px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
              {mode === "edit" && selected?.image && !preview && (
                <div className="mt-2">
                  <p className="mb-1">Current Image:</p>
                  <img
                    src={selected.image}
                    alt="current"
                    style={{
                      width: "140px",
                      height: "110px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
            </div>

            <div className="d-flex justify-content-end gap-2">
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="success">
                {mode === "add" ? "Add" : "Update"}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AboutUs;
